import { ComponentChildren, JSX } from "preact";

interface QuestionContainer {
  legendText: string;
  subtext?: string;
  children?: ComponentChildren;
  role?: JSX.IntrinsicElements['div']['role']
}

const QuestionContainer = ({
  legendText,
  subtext,
  children,
  role,
}: QuestionContainer) => {
  return (
    <fieldset className="lc-flex lc-flex-col lc-justify-center lc-animate-fadeTop" role={role}>
      <legend
        className={`lc-flex lc-text-4xl lg:lc-text-5xl lc-text-pretty lc-leading-tight lc-text-white lc-font-flecha ${
          subtext ? "lc-mb-4 lg:lc-mb-8" : "lc-mb-8 lg:lc-mb-16"
        } lc-text-center`}
      >
        {legendText}
      </legend>
      {subtext && (
        <p className="lc-text-center lc-text-base lc-text-white lc-font-azo-sans lc-mb-4 lg:lc-mb-8">
          {subtext}
        </p>
      )}
      {children}
    </fieldset>
  );
};

export default QuestionContainer;
